export default {
  invalid_password: "Invalid password",
  invalid_bank_account_number: "Invalid bank account number",
  invalid_routing_number: "Invalid routing number",
};